const BASE_URL = process.env.PURCHASE_CUSTOMER_API_URL;

export const PERSONAL_DETAILS_ENDPOINTS = {
  GET_PERSONAL_DETAILS: `${BASE_URL}/api/v1/personaldetails`,
  VALIDATE_ADDRESSES: `${BASE_URL}/api/v1/personaldetails/validate`,
  NORMALIZE_ADDRESSES: `${BASE_URL}/api/v1/personaldetails/normalize`,
  SAVE_DEMOGRAPHICS: `${BASE_URL}/api/v1/personaldetails/demographics`,
  SAVE_ADDRESSES: `${BASE_URL}/api/v1/personaldetails/addresses`,
  SAVE_DELIVERY_ADDRESS: `${BASE_URL}/api/v1/personaldetails/deliveryaddress`
};

export const DRIVERS_LICENSE_ENDPOINTS = {
  GET_DRIVERS_LICENSE: `${BASE_URL}/api/v1/driverslicense`,
  GET_DRIVERS_LICENSE_IMAGE: `${BASE_URL}/api/v1/driverslicense/image`,
  UPLOAD_DRIVERS_LICENSE: `${BASE_URL}/api/v1/driverslicense/upload`,
  UPDATE_DRIVERS_LICENSE_NAME: `${BASE_URL}/api/v1/driverslicense/name`,
  UPLOAD_FALLBACK: `${BASE_URL}/api/v1/driverslicense/upload-fallback`
};

export const DOC_VISION_ENDPOINT = {
  VALIDATE_DOCUMENT: `${BASE_URL}/api/v1/docvision/validate-document`
};

export const EV_TAX_CREDIT_ENDPOINTS = {
  GET_EV_TAX_CREDIT_INFO: `${BASE_URL}/api/v1/evtaxcredit/clean-vehicle-tax-credit-info`,
  SUBMIT_EV_TAX_CREDIT_ELIGIBILITY: `${BASE_URL}/api/v1/evtaxcredit/clean-vehicle-tax-credit-eligibility`
};
